module.exports = __webpack_public_path__ + "media/packs/images/flags/HT-c6b2260fddf064ea2a59ec4dbf02da3e.svg";